/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable arrow-body-style */
/* eslint-disable react/function-component-definition */
/* eslint-disable unicorn/no-useless-undefined */
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";

import { NewIDataUploadItem } from "../../interfaces/IDataUploadItem";
import { IForm } from "../../interfaces/IForm";
import { getListAreaLocation } from "../../pages/view-form/api-endpoint/callApi";
import {
  FilterDistinctByIdAndSort,
  RemoveDateFromFileName,
} from "../../shared/functions";
import AutocompleteComponent from "../autocomplete/autocomplete-mui";
import DropdownlistComponent from "../dropdownlist/dropdownlist-mui";
import Feedback from "../feedback/feedback";
import UploadMultipleFileComponent from "../uploadmultiplefile/UploadMultipleFile";

const LABEL_MAP: Record<string, string> = {
  dateOfPower: "Tanggal Surat Kuasa / Date of Power Attorney",
  signer: "Pihak Penandatangan / Signer",
  titleAgreement: "Judul Perjanjian / Title of Agreement",
  counterPart: "Partner / Counterpart",
  requestType: "Jenis Permohonan / Request Type",
  documentType: "Jenis Dokumen / Document Type",
  address: "Ruang / Room",
  area: "Lokasi / Area",
};

const ConfirmationDialogRevisionUser = ({
  open,
  onConfirm,
  onCancel,
  isMandatory,
  action,
}: {
  open: boolean;
  onConfirm?: ({
    comment,
    data,
  }: {
    comment: string;
    data: NewIDataUploadItem[];
  }) => void;
  onCancel?: () => void;
  isMandatory: boolean;
  action: string;
}) => {
  const [formData, setFormData] = useState<Partial<IForm>>({
    dateOfPower: undefined,
    signer: undefined,
    titleAgreement: undefined,
    counterPart: undefined,
    requestType: undefined,
    documentType: undefined,
    startDatePeriod: undefined,
    endDatePeriod: undefined,
    address: undefined,
    area: undefined,
  });
  const [comment, setComment] = useState("");
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [openFeedback, setOpenFeedback] = useState(false);
  const [listAreaLocation, setListAreaLocation] = useState<
    { label: string; value: string }[]
  >([]);

  const [dataUpload, setDataUpload] = useState<NewIDataUploadItem[]>([
    {
      title: "Bukti / Evidence",
      fileType: "Evidence",
      files: [{ documentID: "", fileBase64: "", fileName: "", folderName: "" }],
    },
  ]);
  const [errorUpload, setErrorUpload] = useState("");

  const listRequestType = useMemo(() => ["Surat Kuasa", "Dokumen Master"], []);

  const listDocumentType = useMemo(() => ["Softcopy", "Hardcopy"], []);

  const handleChange = (e) => {
    setComment(e.target.value);
  };

  const getBase64 = (file: any) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        resolve(reader.result);
      });
      reader.addEventListener("error", (error) => {
        reject(error);
      });
      reader.readAsDataURL(file);
    });

  const handleChangeUpload = async (data, dataIndex, fileIndex) => {
    if (data != undefined) {
      if (data.name.length > 150) {
        setFeedbackText("File name cannot be more than 150 letters!");
        setFeedbackType("failed");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
        }, 2000);
        return;
      }
      const resultBase64File: any = await getBase64(data).then(
        (bs64: any) => bs64
      );

      const newDataUpload = [...dataUpload];
      const newFileNameWithoutDate = RemoveDateFromFileName(data.name);
      const filteredSameFileName = !newDataUpload.some((item) =>
        item.files.some((file) => {
          const existingFileNameWithoutDate = RemoveDateFromFileName(
            file.fileName
          );
          return existingFileNameWithoutDate === newFileNameWithoutDate;
        })
      );

      if (filteredSameFileName) {
        newDataUpload[dataIndex] = {
          title: newDataUpload[dataIndex].title,
          fileType: newDataUpload[dataIndex].fileType,
          files: [...newDataUpload[dataIndex].files],
        };
        newDataUpload[dataIndex].files[fileIndex] = {
          documentID: "",
          fileBase64: resultBase64File,
          fileName: data.name,
          folderName: "",
        };
        setDataUpload(newDataUpload);
        if (
          newDataUpload[dataIndex].title.includes("*") &&
          newDataUpload[dataIndex].files[fileIndex].fileBase64 != ""
        ) {
          setErrorUpload("");
        }
      } else {
        setFeedbackText("The file already exists, please change the file name");
        setFeedbackType("failed");
        setOpenFeedback(true);
        setTimeout(() => {
          setOpenFeedback(false);
        }, 2000);
      }
    }
  };

  const parseString = (data: Partial<IForm>, commentData: string) => {
    const parsedStrings = Object.entries(data)
      .map(([key, value], index) => {
        if (key == "startDatePeriod") {
          return data.startDatePeriod == undefined
            ? undefined
            : `• Periode Penggunaan (Khusus Dokumen Master) / Period of Use (Master Document only): ${data.startDatePeriod} - ${data.endDatePeriod}`;
        }
        if (key == "endDatePeriod") {
          return undefined;
        }
        const label = LABEL_MAP[key] || key;
        const formattedValue =
          typeof value === "object" && value !== undefined
            ? value?.name
            : value;
        return formattedValue && `• ${label}: ${formattedValue}`;
      })
      .filter((e) => e != undefined);

    if (parsedStrings.length === 0) {
      return undefined;
    }

    const result = `${commentData}\n\n\n${
      parsedStrings.length
    } Poin Perubahan / ${
      parsedStrings.length
    } Points of Change:\n\n${parsedStrings.join("\n")}`;

    return result;
  };

  const handleChangeDelete = (dataIndex: number, fileIndex: number) => {
    const newDataUpload = [...dataUpload];
    newDataUpload[dataIndex].files[fileIndex] = {
      documentID: "",
      fileBase64: "",
      fileName: "",
      folderName: "",
    };
    setDataUpload(newDataUpload);
    if (
      newDataUpload[dataIndex].title.includes("*") &&
      newDataUpload[dataIndex].files[fileIndex].fileBase64 == ""
    ) {
      setErrorUpload("Please upload required file");
    }
  };

  const handleChangeDownload = (dataIndex, fileIndex) => {
    const getDataUpload = [...dataUpload];
    const downloadLink = document.createElement("a");
    if (getDataUpload[dataIndex].files[fileIndex].fileBase64 != "") {
      downloadLink.href = getDataUpload[dataIndex].files[fileIndex].fileBase64;
      downloadLink.download =
        getDataUpload[dataIndex].files[fileIndex].fileName;
      downloadLink.click();
    }
  };

  const handleChangeForm = <T extends keyof IForm>(event: any, key: T) => {
    setFormData((prev) => {
      let newValue: any;
      let addressValue: string | undefined;
      let areaValue: string | undefined;

      if (event.target.type === "checkbox") {
        switch (key) {
          case "signer":
            newValue = event.target.checked
              ? { binusianIDEmail: "", name: "" }
              : undefined;
            break;

          case "dateOfPower":
          case "endDatePeriod":
          case "startDatePeriod":
            newValue = event.target.checked
              ? moment().format("YYYY-MM-DD").toString()
              : undefined;
            break;

          case "requestType":
            newValue = event.target.checked ? listRequestType[0] : undefined;
            break;

          case "documentType":
            newValue = event.target.checked ? listDocumentType[0] : undefined;
            areaValue =
              event.target.checked && listDocumentType[0] === "Hardcopy"
                ? listAreaLocation[0].value
                : undefined;
            return {
              ...prev,
              documentType: newValue,
              address: undefined,
              area: areaValue,
            };

          default:
            newValue = event.target.checked ? "" : undefined;
            break;
        }
      } else {
        switch (key) {
          case "dateOfPower":
            newValue = moment(event.target.value)
              .format("YYYY-MM-DD")
              .toString();
            break;

          case "documentType":
            addressValue = event.target.value == "Softcopy" ? undefined : "";
            areaValue =
              event.target.value == "Softcopy" ? undefined : "Anggrek";
            return {
              ...prev,
              documentType: event.target.value,
              address: addressValue,
              area: areaValue,
            };

          default:
            newValue = event.target.value;
            break;
        }
      }

      return { ...prev, [key]: newValue };
    });
  };

  const validateData = (data: Partial<IForm>): boolean => {
    if (
      data.dateOfPower == "Invalid date" ||
      data.signer?.binusianIDEmail == "" ||
      data.titleAgreement == "" ||
      data.counterPart == "" ||
      data.startDatePeriod == "" ||
      data.endDatePeriod == "" ||
      (data.documentType == "Hardcopy" && data.address == "") ||
      parseString(formData, comment) == undefined
    ) {
      return false;
    }
    return true;
  };

  const getAreaLocation = async () => {
    try {
      const tempDataAreaLocation: any = [];
      const ltAreaLocation = await getListAreaLocation();
      const jsonParse = JSON.parse(ltAreaLocation);
      jsonParse.data.forEach((datas: any) => {
        tempDataAreaLocation.push({
          label: datas.locationHierarcy.text,
          value: datas.locationHierarcy.id,
        });
      });
      const distinctLocation = FilterDistinctByIdAndSort(tempDataAreaLocation);
      setListAreaLocation(distinctLocation);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getAreaLocation();
  }, []);

  return (
    <Dialog open={open} onClose={() => {}} maxWidth="md" fullWidth>
      <DialogContent
        style={{
          display: "flex",
          flexDirection: "column",
          width: "full",
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography variant="subtitle1" style={{ marginRight: "1rem" }}>
            <u>
              Perubahan poin dokumen / <i>Document points changes</i>
            </u>
            {isMandatory ? <span style={{ color: "red" }}> *</span> : ""}
          </Typography>
          <Typography variant="subtitle1" style={{ marginRight: "1.5rem" }}>
            {action}
          </Typography>
        </Box>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "1rem",
            width: "full",
          }}
        >
          <div
            style={{ display: "flex", flexDirection: "column", width: "50%" }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => {
                    handleChangeForm(e, "dateOfPower");
                  }}
                  name="DoP"
                  checked={formData.dateOfPower !== undefined}
                />
              }
              label={
                <Typography style={{ fontSize: "15px" }}>
                  Tanggal Surat Kuasa / <i>Date of Power Attorney</i>
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => {
                    handleChangeForm(e, "signer");
                  }}
                  name="signer"
                  checked={formData.signer !== undefined}
                />
              }
              label={
                <Typography style={{ fontSize: "15px" }}>
                  Pihak Penandatangan / Signer
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => {
                    handleChangeForm(e, "titleAgreement");
                  }}
                  name="titleAgreement"
                  checked={formData.titleAgreement !== undefined}
                />
              }
              label={
                <Typography style={{ fontSize: "15px" }}>
                  Judul Perjanjian / Title of Agreement
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => {
                    handleChangeForm(e, "counterPart");
                  }}
                  name="partner"
                  checked={formData.counterPart !== undefined}
                />
              }
              label={
                <Typography style={{ fontSize: "15px" }}>
                  Partner / Counterpart
                </Typography>
              }
            />
          </div>
          <div
            style={{ display: "flex", flexDirection: "column", width: "50%" }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => {
                    handleChangeForm(e, "requestType");
                  }}
                  name="requestType"
                  checked={formData.requestType !== undefined}
                />
              }
              label={
                <Typography style={{ fontSize: "15px" }}>
                  Jenis Permohonan / Request Type
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => {
                    handleChangeForm(e, "documentType");
                  }}
                  name="documentType"
                  checked={formData.documentType !== undefined}
                />
              }
              label={
                <Typography style={{ fontSize: "15px" }}>
                  Jenis Dokumen / Document Type
                </Typography>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) => {
                    handleChangeForm(e, "startDatePeriod");
                    handleChangeForm(e, "endDatePeriod");
                  }}
                  name="periodOfUse"
                  checked={
                    formData.startDatePeriod !== undefined &&
                    formData.endDatePeriod !== undefined
                  }
                />
              }
              label={
                <Typography style={{ fontSize: "15px" }}>
                  Periode Penggunaan (Khusus Dokumen Master) / Period of Use
                  (Master Document only)
                </Typography>
              }
            />
          </div>
        </div>
        {parseString(formData, comment) == undefined && (
          <div className="error-message" style={{ marginBottom: "2rem" }}>
            Please check at least 1 box
          </div>
        )}
        <Grid container>
          {formData?.dateOfPower != undefined && (
            <Grid sm={6}>
              <Typography variant="subtitle1" gutterBottom>
                <u>
                  Tanggal Surat Kuasa / <i>Date of Power of Attorney</i>
                </u>
                <span style={{ color: "red" }}> *</span>
              </Typography>

              <TextField
                type="date"
                style={{ width: "95%" }}
                onChange={(e) => handleChangeForm(e, "dateOfPower")}
                value={formData.dateOfPower}
              />
              {formData.dateOfPower == "Invalid date" && (
                <div className="error-message">
                  Date of Power of Attorney must be filled
                </div>
              )}
            </Grid>
          )}
          {formData?.signer != undefined && (
            <Grid item sm={6}>
              <Formik initialValues={formData} onSubmit={() => {}}>
                {(props) => (
                  <>
                    <Typography variant="subtitle1" gutterBottom>
                      <u>
                        Pihak Penandatangan / <i>Signer</i>
                      </u>
                      <span style={{ color: "red" }}> *</span>
                    </Typography>
                    <AutocompleteComponent
                      propsData={{
                        ...props,
                        handleChange: (e) => {
                          handleChangeForm(e, "signer");
                          props.handleChange(e);
                        },
                      }}
                      name="signer"
                      isCommentForm
                    />
                    {formData.signer?.binusianIDEmail == "" && (
                      <div className="error-message">Signer must be filled</div>
                    )}
                  </>
                )}
              </Formik>
            </Grid>
          )}
          {formData?.titleAgreement != undefined && (
            <Grid item sm={12}>
              <Typography variant="subtitle1" gutterBottom>
                <u>
                  Judul Perjanjian / <i>Title of Agreement</i>
                </u>
                <span style={{ color: "red" }}> *</span>
              </Typography>

              <TextField
                style={{ width: "97.5%" }}
                onChange={(e) => handleChangeForm(e, "titleAgreement")}
                multiline
                minRows={1}
                maxRows={1}
              />
              {formData.titleAgreement == "" && (
                <div className="error-message">
                  Title of Agreement must be filled
                </div>
              )}
            </Grid>
          )}
          {formData?.counterPart != undefined && (
            <Grid sm={12}>
              <Typography variant="subtitle1" gutterBottom>
                <u>
                  Partner / <i>Counterpart</i>
                </u>
                <span style={{ color: "red" }}> *</span>
              </Typography>
              <TextField
                onChange={(e) => handleChangeForm(e, "counterPart")}
                style={{ width: "97.5%" }}
                multiline
                minRows={1}
                maxRows={1}
              />
              {formData.counterPart == "" && (
                <div className="error-message">Counterpart must be filled</div>
              )}
            </Grid>
          )}
          {formData?.requestType != undefined && (
            <Grid sm={6}>
              <Typography variant="subtitle1" gutterBottom>
                <u>
                  Jenis Permohonan / <i>Request Type</i>
                </u>
                <span style={{ color: "red" }}> *</span>
              </Typography>
              <TextField
                select
                onChange={(e) => handleChangeForm(e, "requestType")}
                defaultValue={listRequestType[0]}
                style={{ width: "95%" }}
              >
                {listRequestType.map((option) => (
                  <MenuItem key={option} value={option} selected>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}
          {formData?.documentType != undefined && (
            <Grid sm={6}>
              <Typography variant="subtitle1" gutterBottom>
                <u>
                  Jenis Dokumen / <i>Document Type</i>
                </u>
                <span style={{ color: "red" }}> *</span>
              </Typography>
              <TextField
                select
                onChange={(e) => handleChangeForm(e, "documentType")}
                defaultValue={listDocumentType[0]}
                style={{ width: "95%" }}
              >
                {listDocumentType.map((option) => (
                  <MenuItem key={option} value={option} selected>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}
        </Grid>
        {formData?.documentType != undefined &&
          formData.documentType == "Hardcopy" && (
            <Grid container>
              <Grid sm={6}>
                <Typography variant="subtitle1" gutterBottom>
                  <u>
                    Lokasi / <i>Area</i>
                  </u>
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <div style={{ width: "95%" }}>
                  <DropdownlistComponent
                    propsData={{
                      handleChange: (e) => handleChangeForm(e, "area"),
                      values: formData,
                    }}
                    name="area"
                    ddlData={listAreaLocation}
                  />
                </div>
              </Grid>
              <Grid sm={6}>
                <Typography variant="subtitle1" gutterBottom>
                  <u>
                    Ruang / <i>Room</i>
                  </u>
                  <span style={{ color: "red" }}> *</span>
                </Typography>

                <TextField
                  style={{ width: "95%" }}
                  onChange={(e) => handleChangeForm(e, "address")}
                />
                {formData.address == "" && (
                  <div className="error-message">Room must be filled</div>
                )}
              </Grid>
            </Grid>
          )}
        {formData?.startDatePeriod != undefined &&
          formData?.endDatePeriod != undefined && (
            <>
              <Typography
                variant="subtitle1"
                gutterBottom
                // style={{ marginLeft: "0.5rem" }}
              >
                <u>
                  Periode Penggunaan (Khusus Dokumen Master) /{" "}
                  <i>Period of Use (Master Document only)</i>
                </u>
                <span style={{ color: "red" }}> *</span>
              </Typography>
              <Grid container>
                <Grid sm={6}>
                  <TextField
                    type="date"
                    style={{ width: "95%" }}
                    onChange={(e) => handleChangeForm(e, "startDatePeriod")}
                    value={formData.startDatePeriod}
                  />
                  {formData.startDatePeriod === "" && (
                    <div className="error-message">
                      Start Date Period must be filled
                    </div>
                  )}
                </Grid>
                <Grid sm={6}>
                  <TextField
                    type="date"
                    style={{ width: "95%" }}
                    onChange={(e) => handleChangeForm(e, "endDatePeriod")}
                    value={formData.endDatePeriod}
                  />
                  {formData.endDatePeriod === "" ? (
                    <div className="error-message">
                      End Date Period must be filled
                    </div>
                  ) : formData.startDatePeriod > formData.endDatePeriod ? (
                    <div className="error-message">
                      End Date must not be earlier than Start Date
                    </div>
                  ) : undefined}
                </Grid>
              </Grid>
            </>
          )}
        <Box
          component="form"
          sx={{
            "& .MuiTextField-root": { width: "95%", marginBottom: "2%" },
          }}
          style={{ marginTop: "2rem" }}
          noValidate
          autoComplete="off"
        >
          <Typography
            variant="subtitle1"
            gutterBottom
            style={{ float: "left" }}
          >
            <u>
              Catatan / <i>Note</i>
            </u>
            {isMandatory ? <span style={{ color: "red" }}> *</span> : ""}
          </Typography>
          <TextField
            multiline
            minRows={1}
            value={comment}
            onChange={handleChange}
            style={{ width: "97.5%" }}
          />
          {comment.length <= 2 && isMandatory && (
            <div className="error-message" style={{ marginBottom: "2%" }}>
              Please input note
            </div>
          )}
          {comment.length <= 2 &&
            !isMandatory &&
            dataUpload[0].files[0].fileName != "" && (
              <div className="error-message" style={{ marginBottom: "2%" }}>
                Please input note, because you upload attachment
              </div>
            )}
        </Box>
        {dataUpload.map((obj, i) => (
          <div>
            <UploadMultipleFileComponent
              file={obj}
              fileIndex={i}
              onUploadFile={(data, fileIndex) => {
                handleChangeUpload(data, i, fileIndex);
              }}
              onDeleteFile={(fileIndex) => handleChangeDelete(i, fileIndex)}
              onDownloadFile={(fileIndex) => {
                handleChangeDownload(i, fileIndex);
              }}
              onAddMoreData={() => {
                if (dataUpload[i].files.length < 5) {
                  setDataUpload((prevState) => {
                    const newState = [...prevState];
                    const emptyFile = {
                      documentID: "",
                      fileBase64: "",
                      fileName: "",
                      folderName: "",
                    };
                    if (i >= 0 && i < newState.length) {
                      newState[i].files.push(emptyFile);
                    }

                    return newState;
                  });
                }
              }}
              onDeleteData={(ind) => {
                setDataUpload((prevState) => {
                  const newState = [...prevState];
                  if (
                    i >= 0 &&
                    i < newState.length &&
                    ind >= 0 &&
                    ind < newState[i].files.length
                  ) {
                    newState[i].files.splice(ind, 1);
                  }

                  return newState;
                });
              }}
              requiredValidationMessage={errorUpload}
            />
          </div>
        ))}
        <Feedback
          open={openFeedback}
          message={feedbackText}
          feedbackType={feedbackType}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-evenly" }}>
        {onCancel && (
          <Button
            sx={{ background: "#898989", width: "50%" }}
            variant="contained"
            onClick={() => {
              onCancel();
              setFormData({
                dateOfPower: undefined,
                signer: undefined,
                titleAgreement: undefined,
                counterPart: undefined,
                requestType: undefined,
                documentType: undefined,
                startDatePeriod: undefined,
                endDatePeriod: undefined,
              });
              setComment("");
            }}
            color="primary"
          >
            Cancel
          </Button>
        )}
        {onConfirm && (
          <Button
            sx={{ width: "50%" }}
            variant="contained"
            onClick={() => {
              const content = parseString(formData, comment);
              validateData(formData) &&
                comment.length > 0 &&
                content &&
                onConfirm({
                  comment: content,
                  data: dataUpload,
                });
            }}
            color="primary"
            autoFocus
          >
            OK
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialogRevisionUser;
